// Shared peek event detail shape (no React / path aliases — server-safe).

import type { ActivityDockAssistLevel } from "./assistLevelTypes.js";

export const ACTIVITY_DOCK_PEEK_EVENT = "bb-activity-dock-peek";

export type ActivityDockPeekEventDetail = {
  /** Primary mode id at fire time (e.g. `leads`). */
  mode: string;
  reasonSectionId: string;
  assistLevel: ActivityDockAssistLevel;
  ts: number;
};

export function buildActivityDockPeekEventDetail(input: {
  mode: string;
  reasonSectionId: string;
  assistLevel: ActivityDockAssistLevel;
  nowMs: number;
}): ActivityDockPeekEventDetail {
  return {
    mode: input.mode,
    reasonSectionId: input.reasonSectionId,
    assistLevel: input.assistLevel,
    ts: input.nowMs,
  };
}
